import { createSlice } from "@reduxjs/toolkit";

import { fetchWatchwordsCategories } from "./actions";

export const INITIAL_STATE = {
  isDirty: false,
  isEditing: false,
  isLoading: false,
  locked: null,
  updatedBy: null,
  watchwordListCategories: [],
};

export const watchwordsCategoriesSlice = createSlice({
  name: "categories",
  initialState: INITIAL_STATE,
  reducers: {
    resetCategories: () => INITIAL_STATE,
    removeTypeByIndex: (state, { payload = -1 }) => {
      if (payload > -1) {
        const { watchwordListCategories } = state;
        watchwordListCategories.splice(payload, 1);
        state.watchwordListCategories = watchwordListCategories;
        state.isDirty = true;
      }
    },
    setIsDirty: (state, { payload }) => {
      state.isDirty = Boolean(payload);
    },
    setIsEditing: (state, { payload }) => {
      state.isEditing = Boolean(payload);
    },
    setLocked: (state, { payload }) => {
      state.locked = Boolean(payload);
    },
    setUpdatedBy: (state, { payload }) => {
      state.updatedBy = payload;
    },
    setWatchwordListCategories: (state, { payload }) => {
      state.watchwordListCategories = payload || [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWatchwordsCategories.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(
      fetchWatchwordsCategories.fulfilled,
      (state, { payload }) => {
        const { currentUser, data } = payload || {};
        const { locked, updatedBy, watchwordListCategories = [] } = data || {};

        state.locked = locked;
        state.updatedBy = updatedBy;
        state.watchwordListCategories = watchwordListCategories;
        state.isLoading = false;

        state.data = data || null;

        if (locked && updatedBy === currentUser) {
          state.isEditing = true;
        }
      }
    );
  },
});

export const {
  resetCategories,
  removeTypeByIndex,
  setIsDirty,
  setIsEditing,
  setLocked,
  setUpdatedBy,
  setWatchwordListCategories,
} = watchwordsCategoriesSlice.actions;
